import { Schema } from 'normalizr';

import SingletonDuckEntity from './SingletonDuckEntity';

const entity = new SingletonDuckEntity(
  'customerGenderConfig', { schema: new Schema('customerGenderConfig', { idAttribute: '_id' }) }
);

export { entity };